import React from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

const renterTabs = [
  { to: "/app/search", label: "Search" },
  { to: "/app/inbox", label: "Inbox" },
  { to: "/app/account", label: "Account" },
];

export default function RenterAppLayout() {
  return (
    <div className="renter-shell">
      <header className="renter-shell-header">
        <div className="app-surface renter-shell-bar">
          <Link to="/" aria-label="Rental Highway Home">
            <img
              src="/assets/logo/LogoH.png"
              alt="Rental Highway"
              className="renter-shell-logo"
            />
          </Link>
          <nav className="renter-tabs" aria-label="Renter navigation">
            {renterTabs.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  isActive ? "renter-tab active" : "renter-tab"
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>
      <Outlet />
    </div>
  );
}
